/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'refresh': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M317.099 257.593c52.224-37.205 115.143-57.8 181.475-57.8 191.488 0 342.926 171.691 308.793 369.437-20.821 120.263-113.323 219.591-231.765 248.49-160.996 39.14-315.278-48.696-370.12-192.397-14.563-38.23-62.69-53.931-98.19-26.51-22.641 17.521-27.648 49.493-17.18 76.117 65.764 166.002 226.645 277.504 408.462 277.504 264.42 0 474.34-233.814 434.062-505.97C905.9 265.899 765.042 118.101 585.842 82.944c-126.521-24.804-250.88 5.575-347.819 77.028l-37.433-46.194c-13.653-16.84-40.505-11.72-46.876 8.988L97.28 303.673c-7.396 23.893 11.833 47.673 36.75 45.283l188.758-17.521c21.504-2.048 32.199-27.193 18.545-44.032l-24.234-29.81z"/>'
  }
})
